export const generateStoriesLink =
  'https://support.elements.cloud/en/articles/8120615-generating-stories-with-elementsgpt#h_af2ceef086';
export const generateUPNRecommendationsLink =
  'https://support.elements.cloud/en/articles/11320587-process-diagrams-upn-standards-review';
export const generateAgentRecommendationsLink =
  ' https://support.elements.cloud/en/articles/11407337';
export const generateAgentFinderLink = ' https://support.elements.cloud/en/articles/11718406';
export const shareDiagramLink = 'https://support.elements.cloud/en/articles/1459492-share-diagram';
export const autoGenerateDrilldownLink =
  'https://support.elements.cloud/en/articles/8680561-auto-generate-a-upn-diagram-with-elementsgpt';
export const versionHistoryLink =
  'https://support.elements.cloud/en/articles/986385-diagram-versions-and-publishing-new-diagrams';
export const diagramVersionsPublishing =
  'https://support.elements.cloud/en/articles/986385-diagram-versions-and-publishing-new-diagrams';
